export default __webpack_public_path__ + "static/media/company-logo-default.cc267daf.svg";